import React from "react";
import Table, { KebabMenu } from "../../../components/Common/Table";
import Button from "../../../components/Common/Button";
import { employeeTableColumns, EMPLOYEES_PAGE_TITLE } from "../dataFiles/employeesPageDataFile";

const tabStyle = (isActive) => ({
  background: "none",
  border: "none",
  borderBottom: isActive ? "3px solid #3b82f6" : "3px solid transparent",
  padding: "10px 20px",
  fontSize: "15px",
  fontWeight: isActive ? 600 : 400,
  color: isActive ? "#1e293b" : "#94a3b8",
  cursor: "pointer",
  transition: "color 0.15s ease, border-color 0.15s ease",
});

export default function EmployeesTable({
  data = [],
  branchName,
  onEdit,
  onDelete,
  onAddEmployee,
  activeTab,
  onTabChange,
  allCount,
  employeeCount,
  canEdit = false,
  canDeleteRow = () => false,
  jobTitle = "",
}) {
  const columns = [
    ...employeeTableColumns,
    {
      key: "actions",
      header: "Actions",
      align: "right",
      width: "80px",
      render: (row) => (
        <div className="wg-table__actions">
          <KebabMenu
            items={[
              { label: "Edit", onClick: () => onEdit(row), disabled: !canEdit || (jobTitle === "Branch Admin" && row.role === "org_admin") },
              { label: "Delete", onClick: () => onDelete(row), disabled: !canDeleteRow(row) },
            ]}
          />
        </div>
      ),
    },
  ];

  const count = activeTab === "all" ? allCount : employeeCount;
  const label = activeTab === "all" ? "users" : "employees";

  return (
    <Table
      columns={columns}
      data={data}
      rowKey="email"
      hoverable
      emptyState="No employees found for this branch."
      toolbar={{
        left: (
          <div>
            <h2 className="wg-page-header">{EMPLOYEES_PAGE_TITLE}</h2>
            {branchName && (
              <p style={{ fontSize: "13px", color: "#64748b", margin: "4px 0 0 0" }}>
                {branchName} &middot; {count} {count === 1 ? label.slice(0, -1) : label}
              </p>
            )}
          </div>
        ),
      }}
      header={
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", borderBottom: "1px solid #e2e8f0", marginBottom: "16px" }}>
          <div style={{ display: "flex", gap: "0" }}>
            <button
              type="button"
              style={tabStyle(activeTab === "employees")}
              onClick={() => onTabChange("employees")}
            >
              Employees ({employeeCount})
            </button>
            <button
              type="button"
              style={tabStyle(activeTab === "all")}
              onClick={() => onTabChange("all")}
            >
              All ({allCount})
            </button>
          </div>
          {onAddEmployee && (
            <div style={{ paddingBottom: "8px" }}>
              <Button onClick={onAddEmployee}>+ New Employee</Button>
            </div>
          )}
        </div>
      }
    />
  );
}
